import '../css/index.css';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer';

import './modules/lazyload.js';
import './modules/top.js';
import './modules/top_bg.js';
import './modules/topic.js';
import './modules/confetti.js';
import './modules/bloggers_message.js';

// JSオン時
document.body.classList.remove('no-js');
